import React from 'react';
import PropTypes from 'prop-types';
import OverlayController from "../overlay/OverlayController";
import Dialog from "../overlay/Dialog";
import TextField from "../material/TextField";
import { compose } from 'react-apollo';
import mutationsWorkflow from "../../graphql/mutationsWorkflow";

export default compose(
    mutationsWorkflow.createTransitionEventMutationHoc,
    mutationsWorkflow.updateTransitionEventMutationHoc,
    mutationsWorkflow.deleteTransitionEventMutationHoc
)(class TransitionEventDialog extends React.Component {

    static propTypes = {
        project: PropTypes.object.isRequired,
        transitionEvent: PropTypes.object,
        createTransitionEvent: PropTypes.func.isRequired,
        updateTransitionEvent: PropTypes.func.isRequired,
        deleteTransitionEvent: PropTypes.func.isRequired,
        delegate: PropTypes.shape({
            transitionEventsPanelDidCreateTransitionEvent: PropTypes.func.isRequired,
            transitionEventsPanelDidUpdateTransitionEvent: PropTypes.func.isRequired,
            transitionEventsPanelDidDeleteTransitionEvent: PropTypes.func.isRequired
        }).isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.state = {
            eventName: props.transitionEvent ? props.transitionEvent.name : ''
        };
    }

    onTransitionEventNameChange = (event) => {
        this.setState({eventName: event.target.value});
    };

    onSubmit = (event) => {
        event.preventDefault();
        let transitionEventInput = {
            name: this.state.eventName
        };
        OverlayController.showActivityIndicator();
        if (this.props.transitionEvent) {
            this.props.updateTransitionEvent(this.props.transitionEvent.id, transitionEventInput).then(({data}) => {
                console.log("transition event updated:", data.updateTransitionEvent);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
                this.props.delegate.transitionEventsPanelDidUpdateTransitionEvent(data.updateTransitionEvent);
            }).catch((error) => {
                console.log("error updating transition event:", error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
        } else {
            this.props.createTransitionEvent(this.props.project.id, transitionEventInput).then(({data}) => {
                console.log("transition event created:", data.createTransitionEvent);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
                this.props.delegate.transitionEventsPanelDidCreateTransitionEvent(data.createTransitionEvent);
            }).catch((error) => {
                console.log("error creating transition event:", error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
        }
    };

    onDelete = () => {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Delete', handler: () => {
                OverlayController.showActivityIndicator();
                this.props.deleteTransitionEvent(this.props.transitionEvent.id).then(({data}) => {
                    console.log("transition event deleted:", data.deleteTransitionEvent);
                    OverlayController.hideActivityIndicator();
                    OverlayController.hideOverlay(); // Hide the delete dialog
                    OverlayController.hideOverlay(); // Hide the transition event dialog
                    this.props.delegate.transitionEventsPanelDidDeleteTransitionEvent(data.deleteTransitionEvent);
                }).catch((error) => {
                    console.log("error deleting transition event", error);
                    OverlayController.hideActivityIndicator();
                    OverlayController.showErrorAlert(error);
                });
            }}
        ];
        OverlayController.showOverlay({
            component: <Dialog title={`Delete transition event ${this.props.transitionEvent.name}?`} actions={actions}/>
        });
    };

    onCancel = () => {
        OverlayController.hideOverlay();
    };

    isEnabled() {
        return this.state.eventName.trim().length > 0;
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: this.onCancel},
            {label: this.props.transitionEvent ? 'Save' : 'Create', type: "submit", form: 'transitionEventDialogForm', disabled: !this.isEnabled()}
        ];
        if (this.props.transitionEvent && this.props.transitionEvent.deletePermission.canDelete) {
            actions.push({label: 'Delete', secondary: true, handler: this.onDelete});
        }
        return (
            <Dialog showTitleBar={true} title="Transition Event" actions={actions} className="eventsDialog">
                <form onSubmit={this.onSubmit} id="transitionEventDialogForm">

                    <TextField
                        floatingLabel={true}
                        labelText="Transition Event Name"
                        placeholderText="Enter transition event name"
                        value={this.state.eventName}
                        onChange={this.onTransitionEventNameChange}/>

                </form>
            </Dialog>
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/diagram/TransitionEventDialog.js